import { useEffect, useRef } from "react";
import { trackScrollDepth } from "../lib/analytics";

const THRESHOLDS = [25, 50, 75, 100] as const;
type Threshold = (typeof THRESHOLDS)[number];

// Fires `scroll_depth` events at 25/50/75/100% reached, once each, per mount.
// Used on LandingPage to measure how far campaign visitors actually read before
// bouncing — combined with cta_click, this isolates "no one is scrolling" from
// "people scroll but don't click".
export function useScrollDepth() {
  const fired = useRef<Set<Threshold>>(new Set());

  useEffect(() => {
    function onScroll() {
      const doc = document.documentElement;
      const scrolled = window.scrollY + window.innerHeight;
      const height = doc.scrollHeight;
      if (height <= window.innerHeight) return;
      const percent = (scrolled / height) * 100;
      for (const t of THRESHOLDS) {
        if (percent >= t && !fired.current.has(t)) {
          fired.current.add(t);
          trackScrollDepth(t);
        }
      }
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
}
